import {Component, Input, OnInit} from '@angular/core';
import {UtilService} from '../../services/util.service';
import {SbNavigationPathParam} from '@ngx-seatback/utils';
import {Params} from '@angular/router';
import {PermissionService} from '../../services/permission.service';


@Component({
  selector: 'sb-comp-link',
  templateUrl: './sb-link.component.html',
  styleUrls: ['./sb-link.component.scss'],
  standalone: false,
})
export class SbLinkComponent implements OnInit {
  @Input() set permission(perm: string | string[]) {
    if (perm) {
      if (typeof perm === 'string') {
        this.permissions = [perm];
      } else {
        this.permissions = perm;
      }
    } else {
      this.permissions = [];
    }
  }

  @Input() classes: string;
  @Input() link: string;
  @Input() pathParams: SbNavigationPathParam[];
  @Input() queryParams: Params;
  @Input() title: string;
  @Input() condition: boolean = true;

  @Input() tooltip: string;
  @Input() tooltipPlacement = 'top';
  @Input() tooltipContainer = 'body';

  permissions: string[];

  constructor(
    public util: UtilService,
    public permissionService: PermissionService
  ) {}

  ngOnInit(): void {}
}
